module.exports = __webpack_public_path__ + "assets/ac28a336.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sale-yellow.png
// module id = 104
// module chunks = 0